import { FunctionComponent, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'rootReducer';
import {
  EventPayloadType,
  RecordingPlayClickedPayload,
  sendEvent
} from 'api/v3/send_event';
import { useCurrentRecording } from '../recordingHooks';

export const SendPlayRecordingEvent: FunctionComponent = () => {
  const recording = useCurrentRecording();
  const playing = useSelector((state: RootState) => state.audio.playing);

  useEffect(() => {
    console.debug('Playing:', playing);
    if (playing && recording) {
      console.debug('Will send the play button clicked');

      const payload: RecordingPlayClickedPayload = {
        type: EventPayloadType.RECORDING_PLAY_CLICKED,
        recording_id: recording.id,
        owner_id: recording.userId,
        recording_title: recording.title
      };

      (async () => await sendEvent(payload))();
    }
  }, [playing, recording]);

  return null;
};
